import React from 'react';
import './index.css';


const SAMPLE_TEXT = 'Live subtitles for any audio. Automatically translated.';
const TEXT_SPEED = 50;
const DO_IT_AGAIN_TIMEOUT = 2000;

class SubtitlesDemo extends React.Component {
  state = {text: ''};
  i = 0;

  componentDidMount() {
    this.typeWriter()
  }

  typeWriter = () => {
    if (this.i < SAMPLE_TEXT.length) {
      this.setState({text: this.state.text + SAMPLE_TEXT.charAt(this.i)});
      this.i++;
      setTimeout(this.typeWriter, TEXT_SPEED);
    } else {
      // Do it again!
      setTimeout(() => {
        this.setState({text: ''});
        this.i = 0;
        this.typeWriter();
      }, DO_IT_AGAIN_TIMEOUT);
    }
  };

  render() {
    return (
      <div className="window notranslate">
        <div className="title-bar">
          <div className="buttons">
            <div className="close">
              <a className="close-button"
                 role="button"><span><strong>x</strong></span></a>
            </div>
            <div className="minimize">
              <a className="minimize-button"
                 role="button"><span><strong>&ndash;</strong></span></a>
            </div>
            <div className="zoom">
              <a className="zoom-button"
                 role="button"><span><strong>+</strong></span></a>
            </div>
          </div>
        </div>
        <div className="content">
          <div className="text">
            {this.state.text}
          </div>
        </div>
      </div>
    )
  }
}

export default SubtitlesDemo;



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/Hero/SubtitlesDemo/index.js